import React from 'react';
import { Dialog } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

import { Flex, Image, Text, ButtonFilled, ButtonText, SvgIcon } from '../../../Base';

const styles = {
  paper: {
    borderRadius: '16px',
  },
};

const BlockNavigationDialog = ({ open, onCancel, onConfirm, classes }) => {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      classes={{ paper: classes.paper }}
      fullWidth={true}
      maxWidth={'xs'}
    >
      <Flex
        flexDirection={'column'}
        alignItems={'center'}
        px={7}
        pt={8}
        pb={5}
        style={{ position: 'relative' }}
      >
        <SvgIcon
          icon={SvgIcon.ICON_LIST.CLOSE}
          size={28}
          style={{ position: 'absolute', top: '29px', right: '29px', cursor: 'pointer' }}
          onClick={onCancel}
        />
        <Image src={'/assets/images/quiz/exit-quiz.svg'} mb={3} width={'90px'} />
        <Text textStyle={'heading2'} mb={4}>
          ออกจากควิซ
        </Text>
        <Text textAlign={'center'}>ถ้าต้องการกลับมาทำควิซ</Text>
        <Text textAlign={'center'} mb={7}>
          ระบบจะเริ่มใหม่จากข้อแรก
        </Text>
        <ButtonFilled width={'100%'} onClick={onConfirm} mb={2}>
          ออกจากควิซ
        </ButtonFilled>
        <ButtonText width={'100%'} onClick={onCancel}>
          ทำควิซต่อ
        </ButtonText>
      </Flex>
    </Dialog>
  );
};

BlockNavigationDialog.defaultProps = {
  onCancel: () => {},
  onConfirm: () => {},
};

export default withStyles(styles)(BlockNavigationDialog);
